import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-pixels-icon',
  templateUrl: './design-pixels.component.html'
})
export class DesignPixelsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
